@if (clients().length > 1) {
  <button
    type="button"
    class="flex items-center gap-2 bg-gray-600 text-white px-3 md:px-4 py-2 rounded-md shadow-md client-display client-dropdown-button hover:bg-gray-700"
    [attr.aria-expanded]="menuOpen()"
    aria-haspopup="menu"
    (click)="toggleMenu()">
    <mat-icon class="!text-base !leading-none">business</mat-icon>
    <span class="font-semibold min-w-0 client-name">{{ selectedName() }}</span>
    <mat-icon class="!text-base !leading-none">arrow_drop_down</mat-icon>
  </button>
  @if (menuOpen()) {
    <div class="client-menu" role="menu">
      @if (shouldShowSearch()) {
        <div class="client-search">
          <input
            type="search"
            class="client-search-input"
            placeholder="Search Company"
            [value]="searchTerm()"
            (input)="onSearchChange($event)">
        </div>
      }
      <div class="client-option-list">
        @if (filteredClients().length > 0) {
          @for (client of filteredClients(); track client.mCode) {
            <button
              type="button"
              class="client-option"
              role="menuitem"
              [class.active]="isSelected(client.mCode)"
              [attr.aria-current]="isSelected(client.mCode)"
              (click)="onSelect(client.mCode)">
              <mat-icon class="client-option-icon">business</mat-icon>
              <span class="client-option-name">{{ client.name }}</span>
            </button>
          }
        } @else {
          <div class="client-empty">No results found</div>
        }
      </div>
    </div>
  }
} @else if (clientName()) {
  <div class="flex items-center gap-2 bg-gray-600 text-white px-3 md:px-4 py-2 rounded-md shadow-md client-display">
    <mat-icon class="!text-base !leading-none">business</mat-icon>
    <span class="font-semibold min-w-0 client-name">{{ clientName() }}</span>
  </div>
}
